import type { ListingPromotionWindow } from "@/lib/types/search";

export function isPromotionActive(
  window: ListingPromotionWindow | null | undefined,
  now: Date | number = Date.now(),
) {
  if (!window) return false;
  const time = Number(now);
  return (
    new Date(window.startsAt).getTime() <= time &&
    time < new Date(window.endsAt).getTime()
  );
}
